/*
 * @Author: fz
 * @Date: 2021-08-27 14:06:44
 * @LastEditTime: 2021-08-31 18:21:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 */

import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_BUSI_WEB } = e6ModuleOrderWaybillProcessApi;

// 运单轨迹重跑-新增 --确认
export function confirmRecount(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillRecompute/confirm`,
    method: "post",
    data
  });
}

// 运单轨迹重跑-列表 --事件记录
export function getWaybillEvent(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillRecompute/queryEventList`,
    method: "get",
    params
  });
}

// 运单轨迹重跑-列表
export function getWaybillTrackList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillRecompute/queryPageList`,
    method: "post",
    data
  });
}

// 运单轨迹重跑-新增 列表
export function getWaybillTrackAddList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybillRecompute/queryWaybillList`,
    method: "post",
    data
  });
}
